// JsFromRoutes CacheKey 4d8beed44f7bc063acfd6b3e18ef0036
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  get: definePathHelper('get', '/users/settings'),
  update: definePathHelper('patch', '/users/settings'),
}
